import { getCurrentTimestamp } from 'er2_web_utils'

import * as wsTypes from '../../server/constants/action_types'

/**
 * @flow
 * Join a specific web socket room
 */
export const joinRoom = (roomId: string) => (dispatch, getState, { emit }) => {
    const payload = {
        applicationId: getState().meta.name,
        timestamp: getCurrentTimestamp(),
        roomId,
    }
    emit(wsTypes.WS_JOIN_ROOM, payload)
}

/**
 * @flow
 * Leave a specific web socket room
 */
export const leaveRoom = (roomId: string) => (dispatch, getState, { emit }) => {
    const payload = {
        applicationId: getState().meta.name,
        timestamp: getCurrentTimestamp(),
        roomId,
    }
    emit(wsTypes.WS_LEAVE_ROOM, payload)
}
